var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleChevronUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM17.6719 12.7031C18.1125 13.1438 18.1125 13.8562 17.6719 14.2922C17.2313 14.7281 16.5188 14.7328 16.0828 14.2922L12.0047 10.2141L7.92656 14.2922C7.48594 14.7328 6.77344 14.7328 6.3375 14.2922C5.90156 13.8516 5.89687 13.1391 6.3375 12.7031L11.2031 7.82812C11.6438 7.3875 12.3562 7.3875 12.7922 7.82812L17.6719 12.7031Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronUpSolid);
export default __webpack_public_path__ + "static/media/circle-chevron-up-solid.a1a648168705e79d0a3574b6d6f4d0ce.svg";
export { ForwardRef as ReactComponent };